<app-modal
  [isVisible]="showModal"
  [title]="modalTitle"
  [titleColor]="modalTitleColor"
  [buttons]="modalButtons"
  (modalClosed)="closeBulkUploadModal()"
>
  <div class="mt-6">
    <p class="text-md text-gray-500 mb-6">
      Bulk upload makes it easy to add multiple contacts quickly. Upload a
      .csv file (one contact per row) or paste a list directly. Download our .csv
      template to get started and ensure your file is correctly formatted. The
      system will handle duplicates and invalid entries automatically.
    </p>
  </div>

  <div class="mt-8">
    <div class="flex flex-row space-x-2 text-xs text-blue-royal">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
        />
      </svg>
      <button class="text-blue-royal" (click)="downloadCSV()">
        Download template csv file
      </button>
    </div>
  </div>

  <div
    class="mt-3 w-full flex sm:flex-row flex-col sm:space-x-4 space-x-0 space-y-4 sm:space-y-0"
  >
    <!-- excel list  -->
    <div
      (click)="selectExcel()"
      class="sm:w-1/2 rounded-lg border flex flex-col space-y-3 px-3 py-4 border-blue-royal cursor-pointer"
    >
      <div class="flex flex-row justify-between">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-8 text-blue-royal"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
          />
        </svg>

        <div class="cursor-pointer">
          <div
            class="w-6 h-6 rounded-full border-2 flex items-center justify-center"
            [ngClass]="{
              'border-gray-400': !isExcelSelected,
              'border-primary bg-primary': isExcelSelected
            }"
          >
            <div
              class="w-3 h-3 bg-white rounded-full"
              [ngClass]="{
                invisible: !isExcelSelected,
                visible: isExcelSelected
              }"
            ></div>
          </div>
        </div>
      </div>
      <p class="font-extrabold text-md">Upload an excel list</p>

      <p class="text-sm text-gray-500">
        Upload your .csv file to easily add multiple contacts at once. Ensure each
        entry is on a separate row for accuracy.
      </p>
    </div>
    <!-- email adresses -->
    <div
      (click)="selectPasteEmails()"
      class="sm:w-1/2 rounded-lg border flex flex-col space-y-3 px-3 py-4 border-blue-royal cursor-pointer"
    >
      <div class="flex flex-row justify-between">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-8 text-blue-royal"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
          />
        </svg>

        <div class="cursor-pointer">
          <div
            class="w-6 h-6 rounded-full border-2 flex items-center justify-center"
            [ngClass]="{
              'border-gray-400': !isEmailsSelected,
              'border-primary bg-primary': isEmailsSelected
            }"
          >
            <div
              class="w-3 h-3 bg-white rounded-full"
              [ngClass]="{
                invisible: !isEmailsSelected,
                visible: isEmailsSelected
              }"
            ></div>
          </div>
        </div>
      </div>
      <p class="font-extrabold text-md">Paste email addresses</p>

      <p class="text-sm text-gray-500">
        Paste your list of emails below, one per line, to quickly add them in
        bulk. Duplicate entries will be ignored.
      </p>
    </div>
  </div>
</app-modal>

<app-modal
  [isVisible]="showUploadExcelModal"
  [title]="uploadExcelModalTitle"
  [titleColor]="uploadExcelModalTitleColor"
  [buttons]="uploadExcelModalButtons"
  (modalClosed)="closeExcelUploadModal()"
>
  <div class="mt-6">
    <p class="text-md text-gray-500 mb-6">
      Upload your .csv file to easily add multiple contacts at once. Ensure each
      entry is on a separate row for accuracy.
    </p>
  </div>

  <!-- Content type toggle -->
  <div class="mt-4 mb-6">
    <p class="text-sm font-bold text-black dark:text-white mb-2">File content type</p>
    <div class="flex items-center space-x-4">
      <div (click)="selectBatchType('email')" class="flex items-center cursor-pointer">
        <div
          class="w-5 h-5 rounded-full border-2 flex items-center justify-center mr-2"
          [ngClass]="{
            'border-gray-400': batchType !== 'email',
            'border-primary bg-primary': batchType === 'email'
          }"
        >
          <div
            class="w-2 h-2 bg-white rounded-full"
            [ngClass]="{
              invisible: batchType !== 'email',
              visible: batchType === 'email'
            }"
          ></div>
        </div>
        <span class="text-sm">Email addresses</span>
      </div>
      <div (click)="selectBatchType('linkedin')" class="flex items-center cursor-pointer">
        <div
          class="w-5 h-5 rounded-full border-2 flex items-center justify-center mr-2"
          [ngClass]="{
            'border-gray-400': batchType !== 'linkedin',
            'border-primary bg-primary': batchType === 'linkedin'
          }"
        >
          <div
            class="w-2 h-2 bg-white rounded-full"
            [ngClass]="{
              invisible: batchType !== 'linkedin',
              visible: batchType === 'linkedin'
            }"
          ></div>
        </div>
        <span class="text-sm">LinkedIn URLs</span>
      </div>
    </div>
  </div>

  <div class="mt-4">
    <p class="text-sm font-bold text-black dark:text-white">Upload your file</p>
  </div>
  <div
    class="flex flex-row justify-between w-full sm:space-x-0 space-x-4 mb-3 mt-2"
  >
    <p class="text-sm text-gray-800 dark:text-white">
      Select a file containing your contacts to import
    </p>

    <div class="flex flex-row space-x-2 text-xs text-blue-royal">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="size-4"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
        />
      </svg>
      <button class="text-blue-royal" (click)="downloadCSV()">
        Download template file (.csv)
      </button>
    </div>
  </div>

  <div
    class="w-full p-6 border-2 border-dashed border-gray-300 rounded-md justify-center items-center flex flex-col space-y-1"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [ngClass]="{
    'bg-gray-100': isDragging,
    'bg-white': !isDragging
  }"
  >
    <!-- Show when no file is selected -->
    <div *ngIf="!file" class="flex flex-col items-center">
      <svg
        class="w-10 h-10 text-gray-500 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 5v9m-5 0H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2M8 9l4-5 4 5m1 8h.01"
        />
      </svg>

      <p class="text-gray-500 text-sm">
        <span class="underline text-blue-royal cursor-pointer" (click)="triggerFileInput()">Upload a file</span>
        or drag and drop
      </p>
    </div>

    <!-- Show when file is selected -->
    <div *ngIf="file" class="flex flex-col items-center w-full">
      <div class="flex items-center mt-2 bg-gray-100 rounded-md p-2 w-full max-w-md">
        <svg
          class="w-6 h-6 text-gray-500 mr-2"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <span class="text-gray-600 text-sm truncate">{{ file.name }}</span>
      </div>

      <div class="flex mt-3">
        <button
          class="text-blue-royal text-sm mr-4"
          (click)="triggerFileInput()"
        >
          Change file
        </button>
        <button
          class="text-red-500 text-sm"
          (click)="removeFile()"
        >
          Remove
        </button>
      </div>
    </div>

    <input
      type="file"
      class="hidden"
      #fileInput
      (change)="onFileSelected($event)"
      accept=".csv"
    />
    <p class="text-gray-500 text-xs">.csv up to 10mb</p>
  </div>

  <div *ngIf="uploadExcelErrorMessage" class="mt-2 text-sm text-red-500">
    {{ uploadExcelErrorMessage }}
  </div>
</app-modal>

<app-modal
  [isVisible]="showPasteEmailsModal"
  [title]="pasteEmailsModalTitle"
  [titleColor]="pasteEmailsModalTitleColor"
  [buttons]="pasteEmailsModalButtons"
  (modalClosed)="closePasteEmailsModal()"
>
  <div class="mt-6">
    <p class="text-md text-gray-500 mb-6">
      Paste your list of emails below, one per line, to quickly add them in
      bulk. Duplicate entries will be ignored.
    </p>
  </div>

  <div class="mt-8">
    <p class="text-sm font-bold dark:text-white">Paste email addresses</p>
  </div>

  <div class="w-full">
    <textarea
      [(ngModel)]="pasteEmailsInput"
      class="w-full p-4 border border-gray-300 rounded-md text-gray-700 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary resize-y"
      rows="5"
      [placeholder]="pasteEmailsPlaceholder"
    ></textarea>
    <div
      *ngIf="errorMessage"
      class="mt-2 p-2 h-12 text-sm text-red-500 line-clamp-3"
    >
      {{ errorMessage }}
    </div>
  </div>
</app-modal>

<app-modal
  *ngIf="showUploadExcelModalSuccess"
  [isVisible]="showUploadExcelModalSuccess"
  [title]="uploadExcelModalSuccessTitle"
  [titleColor]="uploadExcelModalSuccessTitleColor"
  [buttons]="uploadExcelModalSuccessButtons"
  (modalClosed)="closeExcelUploadModalSuccess()"
>
  <div class="mt-3">
    <p class="text-md text-gray-500">
      We've verified and added
      <span class="font-bold">{{ excelNumberOfLinkedinUrls }}</span>
      {{ batchType === 'email' ? 'email addresses' : 'LinkedIn URLs' }}
      to your list. Everything looks great!
    </p>
  </div>

  <!--
  <div class="flex py-2">
    <p class="text-sm text-center w-full font-normal text-gray-500 dark:text-white">
      {{ uploadedExcelFileName }}
    </p>
  </div>
  -->
</app-modal>

<app-modal
  *ngIf="showUploadExcelModalFailed"
  [isVisible]="showUploadExcelModalFailed"
  [title]="uploadExcelModalFailedTitle"
  [titleColor]="uploadExcelModalFailedTitleColor"
  [buttons]="uploadExcelModalFailedButtons"
  (modalClosed)="closeExcelUploadModalFailed()"
>
  <div class="mt-6">
    <p class="text-md text-gray-500 mb-4">
      Please check your file for errors like invalid
      {{ batchType === 'email' ? 'email addresses' : 'LinkedIn URLs' }}
      and try again. You can also
      <span class="text-blue-royal"> Download template file (.csv)</span>
      for proper formatting.
    </p>
  </div>

  <div *ngIf="uploadExcelErrorModalMessage" class="text-sm text-red-500">
    {{ uploadExcelErrorModalMessage }}
  </div>
</app-modal>

<app-modal
  [isVisible]="showPasteEmailsModalSuccess"
  [title]="pasteEmailsModalSuccessTitle"
  [titleColor]="pasteEmailsModalSuccessTitleColor"
  [buttons]="pasteEmailsModalSuccessButtons"
  (modalClosed)="closePasteEmailsModalSuccess()"
>
  <div class="mt-6">
    <p class="text-md text-gray-500 mb-6">
      We've verified and added
      <span class="font-bold">
        {{ uploadedEmailsCount }}
      </span>
      email addresses to your list. Everything looks great!
    </p>
  </div>
</app-modal>

<app-modal
  [isVisible]="showPasteEmailsModalFailed"
  [title]="pasteEmailsModalFailedTitle"
  [titleColor]="pasteEmailsModalFailedTitleColor"
  [buttons]="pasteEmailsModalFailedButtons"
  (modalClosed)="closePasteEmailsModalFailed()"
>
  <div class="mt-6">
    <p class="text-md text-gray-500 mb-6">
      Please check your email addresses for errors and try again.
    </p>
  </div>

  <div *ngIf="errorMessage" class="text-sm text-red-500">
    {{ errorMessage }}
  </div>
</app-modal>

<app-modal
  [isVisible]="showUploadExcelLoadingModal"
  [title]="showUploadExcelLoadingModalTitle"
  [titleColor]="showUploadExcelLoadingModalTitleColor"
  [buttons]="showUploadExcelLoadingModalButtons"
  (modalClosed)="closeUploadExcelLoadingModal()"
>
  <div class="mt-8 flex items-center justify-center h-full">
    <div>
      <svg
        class="mx-auto animate-spin h-6 w-6 text-primary mb-3"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <h1
        class="text-sm font-semibold leading-none tracking-tight text-primary"
      >
        Please wait while your data is uploading.
      </h1>
    </div>
  </div>
</app-modal>
